import React, { PropsWithChildren } from 'react';
import { Inline } from 'components/layout';

export type StructuredListSecondaryActionsProps = React.HTMLAttributes<HTMLDivElement>;

export const StructuredListSecondaryActions = ({
  children,
  ...props
}: PropsWithChildren<StructuredListSecondaryActionsProps>) => {
  return (
    <Inline alignX="left" spacing={2} {...props}>
      {children}
    </Inline>
  );
};
